import React from "react";

function Icon({ className = "", Component, fill, ...rest }) {
  return <Component className={className} fill={fill} {...rest} />;
}

export default Icon;
